import { computed, inject, Injectable, signal } from '@angular/core';
import { CmsApiService } from './api/cms-api.service';
import { combineLatest } from 'rxjs';
import { CmsContentMapperService } from './cms-content-mapper.service';
import { map, switchMap } from 'rxjs/operators';
import { LanguageService } from './language.service';
import { UserService } from './user/user.service';
import { ArrayService, PlatformService } from 'ngx-unificator/services';
import { UntilDestroy } from 'ngx-unificator/decorator';
import { PaymentType } from '../types/banking-type';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class BankingService {
  private _api = inject(CmsApiService);
  private _mapper = inject(CmsContentMapperService);
  private _languageService = inject(LanguageService);
  private _array = inject(ArrayService);
  private _user = inject(UserService);
  private _platform = inject(PlatformService);

  /**
   * Order for segment sort deposit
   * @private
   */
  public orderPaymentsCrypto: string[] = ['BTC', 'BCH', 'ETH', 'LTC', 'DOG', 'USDT', 'XRP', 'ADA', 'TRX', 'BNB'].map((item) => item + '_coinspaid');

  public _payments = signal<PaymentType>({
    deposit: [],
    withdraw: [],
  });
  public depositPayments = computed(() => this._payments().deposit);
  public withdrawPayments = computed(() => this._payments().withdraw);
  public mergedPayments = computed(() => this._array.uniqueBy('id', [...this._payments().deposit, ...this._payments().withdraw]));

  public fetchPayments(isBankingPage = false) {
    if (!this._platform.isBrowser && !isBankingPage) {
      return;
    }
    this._languageService.langChange$
      .pipe(
        switchMap(() =>
          combineLatest([this.getPaymentMethodsByType('deposit', Number(this._user.auth)), this.getPaymentMethodsByType('cashout', Number(this._user.auth))]),
        ),
      )
      .subscribe(([deposit, withdraw]) => {
        this._updatePaymentStateEntities({ deposit, withdraw });
      });
  }
  /**
   * Get payment methods from CMS by type
   */
  getPaymentMethodsByType(type: string, sort_auth_player: number) {
    return this._api.paymentList({ type, sort_auth_player }).pipe(
      map((response) =>
        this._mapper.mapCmsData(response.data, {
          id: 'id',
          slug: 'slug',
        }),
      ),
      map((list: any[]) => list.filter((e) => e.id)),
      map((list: any[]) =>
        list.map((item) => {
          return {
            ...item,
            image: item.Image,
          };
        }),
      ),
    );
  }
  private _updatePaymentStateEntities(entity: Partial<PaymentType>) {
    this._payments.update((state) => {
      return {
        ...state,
        ...entity,
      };
    });
  }
}
